/**
 * Welcome Splash Content Configuration
 * Contains the content displayed in the welcome splash screen
 */

export const welcomeContent = {
  title: "About Global Mining Risk",

  // HTML content for display
  html: `
    <h2><em>About Global Mining Risk</em></h2>

    <p>Global Mining Risk is a platform drawing together data and expert insight on the global mining sector as it becomes increasingly competitive and critical to the growth of key economic sectors.</p>

    <p>This website includes data and visualizations of both the geographic distribution of mining sites worldwide and the risk of disruption at each site. It addresses a gap in existing information resources by providing site-level analysis of factors that could disrupt mine production and impact the interests of commercial and strategic stakeholders.</p>

    <p>Our methodology evaluates, filters, and integrates several publicly-available data sources to determine mine locations globally. We apply AI with expert human oversight to generate detailed analysis of local, regional, and national events that can influence mine operations and produce quantifiable risk scores for each mine site.</p>

    <p>Global Mining Risk was developed by industry professionals with decades of experience in natural resources, manufacturing, technology, consulting, and data analysis.</p>
  `,

  // Plain text version for accessibility or other uses
  text: `About Global Mining Risk

Global Mining Risk is a platform drawing together data and expert insight on the global mining sector as it becomes increasingly competitive and critical to the growth of key economic sectors.
This website includes data and visualizations of both the geographic distribution of mining sites worldwide and the risk of disruption at each site. It addresses a gap in existing information resources by providing site-level analysis of factors that could disrupt mine production and impact the interests of commercial and strategic stakeholders.
Our methodology evaluates, filters, and integrates several publicly-available data sources to determine mine locations globally. We apply AI with expert human oversight to generate detailed analysis of local, regional, and national events that can influence mine operations and produce quantifiable risk scores for each mine site.
Global Mining Risk was developed by industry professionals with decades of experience in natural resources, manufacturing, technology, consulting, and data analysis.`,

  // Configuration options
  meta: {
    version: "1.0.0",
    lastUpdated: "2025-09-21",
    author: "Global Mining Risk Team"
  }
};

// Default export for easy importing
export default welcomeContent;